import { type MetaIntroProps } from "@op/puck-types";
import { FormattedDate, useContent, useTranslation } from "@op/utils";
import Medium from "../../../../../components/puck/Medium/Medium";
import {
  Dc_MetaIntro_DrawerContent,
  Dc_Popover_Card_CiteAs,
  Print_Dc_CoverPage,
} from "@op/sf-op";

const MetaIntro = ({
  hero,
  title,
  authors = [],
  languageLinks: _languageLinks = [],
  citation,
  doi: _doi,
  contact: _contact,
  copyrightNote: _copyrightNote,
  imageCredits: _imageCredits = [],
}: MetaIntroProps) => {
  const { meta } = useContent();
  const { metaIntro: trans } = useTranslation();

  const articleCitation = citation
    ? citation
    : `${authors.map((author) => author.name).join(", ")}, "${title}"`;

  return (
    <Print_Dc_CoverPage
      title={title}
      documentType={meta.projectName ?? "Dossier"}
      imageSlot={
        hero && (
          <Medium
            medium={{
              ...hero,
              metadata: {
                ...hero.metadata,
                altText: "",
                isFigure: false,
                isExpandable: false,
                source: {
                  url: undefined,
                  title: undefined,
                },
              },
            }}
          />
        )
      }
      publishedText={trans.published}
      publicationDate={
        meta.publishedAt ? (
          <FormattedDate date={meta.publishedAt} />
        ) : (
          trans.notYetPublished
        )
      }
      authorsSlot={authors?.map((author) => (
        <Dc_MetaIntro_DrawerContent.AuthorCard
          key={`${author.name}`}
          placeOfWork={author.position}
          authorName={author.name}
          linkSlot={
            author.profileUrl && (
              <a href={author.profileUrl} target="_blank">
                <Dc_MetaIntro_DrawerContent.AuthorCardLink>
                  {author.profileUrl}
                </Dc_MetaIntro_DrawerContent.AuthorCardLink>
              </a>
            )
          }
        />
      ))}
      translationLinkSlot={
        <Dc_Popover_Card_CiteAs.CiteAsContent>
          {trans.cite}: {articleCitation}
        </Dc_Popover_Card_CiteAs.CiteAsContent>
      }
    />
  );
};

export default MetaIntro;
